export default [
  // {
  //   path: '/course-manage',
  //   name: 'course-manage',
  //   component: () => import(/* webpackChunkName: "course-manage" */ './course/course-manage.vue'),
  //   meta: {
  //     menuCode: 'pcCourseManage',
  //   },
  // },
  // {
  //   path: '/cu-course',
  //   name: 'cu-course',
  //   component: () => import(/* webpackChunkName: "cu-course" */ './course/cu-course.vue'),
  //   meta: {
  //     noCache: true,
  //   },
  // },
];
